import React from "react";

export default function PostCard({ post }) {
  const {
    _id: id,
    title,
    content,
    isAnonymous,
    createdAt,
    commentsCount = 0,
    type,
    authorId,
  } = post || {};

  const authorName = isAnonymous ? "Anonymous" : (authorId?.name || authorId?.username || "User");
  const time = createdAt ? new Date(createdAt).toLocaleString() : "";
  const authorAvatar = authorId?.avatar || authorId?.profilePicture;
  const firstLetter = authorName.charAt(0).toUpperCase();

  const basePath = type === "PRAISE" ? "/praise" : "/prayers";
  return (
    <article className="rounded-lg border bg-white p-3 sm:p-5 shadow-sm">
      <div className="mb-3 sm:mb-4">
        {title && (
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
            <a 
              href={`${basePath}/${id}`}
              className="hover:text-blue-600 hover:underline transition-colors duration-200"
            >
              {title}
            </a>
          </h3>
        )}
            <div 
              className="text-sm text-gray-600 line-clamp-3"
              dangerouslySetInnerHTML={{ __html: content }}
            />
      </div>

      <footer className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0 sm:justify-between">
        <div className="flex items-center gap-4 sm:gap-6">
          <div className="flex items-center gap-2 py-1.5">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="gray" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="lucide lucide-message-circle-icon lucide-message-circle">
            <path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/>
          </svg>
            <span className="text-sm font-semibold text-gray-700">{commentsCount}</span>
          </div>
          
          <div className="flex items-center gap-3 sm:gap-4">
            {authorAvatar && !isAnonymous ? (
              <img
                className="w-8 h-8 sm:w-10 sm:h-10 rounded-full object-cover border-2 border-gray-100 shadow-sm"
                src={authorAvatar}
                alt={authorName}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
            ) : null}
            <div 
              className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-sm sm:text-base font-bold text-white shadow-sm border-2 border-gray-100 ${authorAvatar && !isAnonymous ? 'hidden' : 'flex'}`}
              style={{
                backgroundColor: isAnonymous ? '#6b7280' : '#0074B9'
              }}
            >
              {isAnonymous ? '?' : firstLetter}
            </div>
            <div className="flex flex-col gap-1">
              <span className="text-sm sm:text-base font-semibold text-gray-900">{authorName}</span>
              <span className="text-xs text-gray-500">{time}</span>
            </div>
          </div>
        </div>

        <a 
          className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 self-start sm:self-auto" 
          href={`${basePath}/${id}`}
        >
          Read more
        </a>
      </footer>
    </article>
  );
}


